import React from 'react'
import { Dimmer,Button, Form, Icon, Grid, Card, Table } from "tabler-react";
import { Crud_Catalogos, Crud_error } from '../../../../herramientas/Crud_Catalogos';
import { NotificationManager} from 'react-notifications';
var currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
class ReactivarMovimientos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
         idMovimiento:"",
         movi:[],
         dimmerCarga:false,
         tabla:""

    };
    this.movimiento=[]
  }
  onChangeBuscador=(event)=>{
      this.setState({idMovimiento: event.target.value})
  }
 
  buscarMovimiento=()=>{
    this.setState({dimmerCarga:!this.state.dimmerCarga}) 
    Crud_Catalogos("navieraMovimientos/"+this.state.idMovimiento,"","get","",[],"","","",[]).then((returnVal)=>{
       
       this.setState({movi:returnVal});

       if(this.state.movi){
           if (this.state.movi.length>1){
                 this.state.movi.map((data,index)=>{
                  this.setState({tabla:<Table.Row>
                     <Table.Col>{data.idPlataforma.nombre}</Table.Col>
                     <Table.Col>{data.idOtd.nombre}</Table.Col>
                     <Table.Col>{data.movi.booking}</Table.Col>
                     <Table.Col>{data.idOperacionTipo.nombre}</Table.Col>
                     <Table.Col>{data.idOperacioneEstatus.nombre}</Table.Col>
                     <Table.Col>{data.idRuta.nombre}</Table.Col>
                     <Table.Col>{data.idMovimientoTipo.nombre}</Table.Col>
                     <Table.Col>{data.idTransportista.nombre}</Table.Col>
                     <Table.Col>{data.idTransportista.contactoNombre}</Table.Col>
                     <Table.Col>{data.idCliente.nombreCorto}</Table.Col>
                     <Table.Col>{data.idCorredor.nombre}</Table.Col>   
            </Table.Row>});
                 })
                 
           }
           else{
              this.setState({tabla:<Table.Row>
                <Table.Col>{this.state.movi.idPlataforma.nombre}</Table.Col>
                <Table.Col>{this.state.movi.idOtd.nombre}</Table.Col>
                <Table.Col>{this.state.movi.booking}</Table.Col>
                <Table.Col>{this.state.movi.idOperacionTipo.nombre}</Table.Col>
                <Table.Col>{this.state.movi.idOperacionEstatus.nombre}</Table.Col>
                <Table.Col>{this.state.movi.idRuta.nombre}</Table.Col>
                <Table.Col>{this.state.movi.idMovimientoTipo.nombre}</Table.Col>
                <Table.Col>{this.state.movi.idTransportista.nombre}</Table.Col>
                <Table.Col>{this.state.movi.idTransportista.contactoNombre}</Table.Col>
                <Table.Col>{this.state.movi.idCliente.nombreCorto}</Table.Col>
                <Table.Col>{this.state.movi.idCorredor.nombre}</Table.Col>
                <Table.Col>{<Button pill size="sm" fill color="info" onClick={()=>this.reMovimiento(this.state.movi.id)}>Reactivar</Button>}</Table.Col> 
                 
       </Table.Row>});
       
       this.setState({dimmerCarga:!this.state.dimmerCarga}) 
           }
          } 
         else{
          this.setState({tabla:<div>No hay informacion disponible</div>})
           this.setState({dimmerCarga:!this.state.dimmerCarga}) 
         }    
         
      
  
      }).catch(err =>{ console.log(err);});
  }
  
  reMovimiento = (idMovimiento) =>{
    Crud_Catalogos("navieraMovimientos/reactivar/"+this.state.idMovimiento,"","get","",[],"","","",[]).then((returnVal)=>{
    NotificationManager.info(returnVal, returnVal);
       
    }).catch(err =>{ console.log(err);});
  }
  render() {
    return (
      <div>
        {/**
          *   Elementos de plataformas
          */
        }
        {
          <div>
              
            <Grid.Row>
              <Grid.Col>
              <Dimmer active={this.state.dimmerCarga} loader>
                <Card title="Reactivacion del movimiento" isCollapsible={false} isCollapsed={false}//isClosable
                  options={<Form.Group>
                      <Grid.Row>
                        <Grid.Col>
                    <span className="float-right">
                      <Form.Input className="mb-3" placeholder="Ingresa id mov..." position="append" onChange={this.onChangeBuscador} />
                    </span>
                    </Grid.Col>
                    <Grid.Col>
                    <Button pill size="sm" outline color="info" onClick={()=>this.buscarMovimiento()}>Buscar</Button>
                    </Grid.Col>
                    </Grid.Row>
                  </Form.Group>}
                  body={
                    <div>
                      <Form.Group>
                        
                        <Table cards={true} striped={true} responsive={true} className="table-vcenter" >
                          <Table.Header>
                            <Table.ColHeader>PLATAFORMA</Table.ColHeader>
                            <Table.ColHeader>OTD</Table.ColHeader>
                            <Table.ColHeader>BOOKING</Table.ColHeader>
                            <Table.ColHeader>TIPO DE OPERACION</Table.ColHeader>
                            <Table.ColHeader>STATUS DE OPERACION</Table.ColHeader>
                            <Table.ColHeader>RUTA</Table.ColHeader>
                            <Table.ColHeader>TIPO DE MOVIMIENTO</Table.ColHeader>
                            <Table.ColHeader>TRANSPORTISTA</Table.ColHeader>
                            <Table.ColHeader>CONTACTO TRANSPORTISTA</Table.ColHeader>
                            <Table.ColHeader>NOMBRE DEL CLIENTE</Table.ColHeader>
                            <Table.ColHeader>CORREDOR</Table.ColHeader>
                          </Table.Header>
                          <Table.Body>
                          
                            {
                           this.state.tabla=== "" ?
                          null : this.state.tabla
                            }
                            
                          </Table.Body>
                        </Table>
                      </Form.Group>
                    </div>
                  }
                />
                  </Dimmer>
              </Grid.Col>

            </Grid.Row>
           
          </div>
          
          }
      </div>
      
    )
  }
}
export default ReactivarMovimientos;
